import { z } from 'zod';
import { email, password, requiredText, optionalText } from './common';

export const signupSchema = z.object({
  name: requiredText(120, 'Informe seu nome'),
  email,
  password,
  phone: optionalText(30),
  storeName: requiredText(80, 'Informe o nome da loja'),
  segment: z.string().max(40).default('outro'),
  acceptTerms: z.literal(true, { message: 'É preciso aceitar os termos de uso' }),
  referral: optionalText(60),
});
export type SignupInput = z.infer<typeof signupSchema>;

export const loginSchema = z.object({
  email,
  password: z.string().min(1, 'Informe a senha').max(128),
  clientType: z.enum(['web', 'mobile', 'desktop']).default('web'),
  deviceName: optionalText(80),
});
export type LoginInput = z.infer<typeof loginSchema>;

export const mfaVerifySchema = z.object({
  challengeToken: z.string().min(10).max(200),
  code: z.string().trim().min(6).max(20),
});

export const forgotPasswordSchema = z.object({ email });

export const resetPasswordSchema = z.object({
  token: z.string().min(10).max(200),
  password,
});

export const verifyEmailSchema = z.object({ token: z.string().min(10).max(200) });

export const changePasswordSchema = z.object({
  currentPassword: z.string().min(1).max(128),
  newPassword: password,
});

export const reauthSchema = z.object({
  password: z.string().min(1).max(128),
});

export const mfaEnableSchema = z.object({ code: z.string().trim().regex(/^\d{6}$/, 'Código de 6 dígitos') });
export const mfaDisableSchema = z.object({
  password: z.string().min(1).max(128),
  code: z.string().trim().min(6).max(20),
});

export const switchCompanySchema = z.object({ companyId: z.string().uuid() });

export const acceptInviteSchema = z.object({
  token: z.string().min(10).max(200),
  /** Obrigatório quando o convidado ainda não tem conta. */
  name: optionalText(120),
  password: password.optional(),
});

export const impersonateSchema = z.object({ token: z.string().min(10).max(200) });

export const updateProfileSchema = z.object({
  name: requiredText(120),
  phone: optionalText(30),
});
